var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.35,
    width: 19.3,
    height: 19.3,
    rx: 3.65,
    fill: "white",
    stroke: "#DADADA",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7427 6.55555L13.4991 5.31187C13.3333 5.14616 13.1125 5.05476 12.8775 5.05469H12.8771C12.642 5.05469 12.4214 5.14593 12.2558 5.31157L5.91498 11.6523C5.86302 11.7055 5.84166 11.7811 5.82625 11.8285L5.01127 14.681C4.98205 14.7834 5.01059 14.8936 5.08581 14.9688C5.14158 15.0246 5.2165 15.0547 5.2931 15.0547C5.32004 15.0547 5.34712 15.051 5.37367 15.0434L8.22455 14.2289C8.233 14.2265 8.35895 14.1831 8.40236 14.1397L14.7431 7.79891C14.9089 7.63319 15 7.41241 15 7.17719C14.9999 6.94214 14.9085 6.72132 14.7427 6.55555ZM5.71997 14.3347L6.53686 11.8596L8.19509 13.5178L5.71997 14.3347ZM8.19509 13.5178L6.53686 11.8596L11.6336 6.76282L13.2918 8.4211L8.19509 13.5178ZM14.5832 7.05469L12.8775 5.31187L12.0481 6.34823L12.6703 5.72615C12.7252 5.67122 12.7987 5.64101 12.8771 5.64101C12.9557 5.64101 13.0295 5.67137 13.0845 5.72646L14.3282 6.97014C14.4425 7.08441 14.6973 6.94055 14.5832 7.05469Z",
    fill: "#747373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.25ab2a3a4504c871d4f80a2bbfe188e7.svg";
export { ForwardRef as ReactComponent };